export const RecruitmentDecision = {
    path: '/recruitment_decisions',
    name: 'recruitment_decisions',
    component: () => import('@/views/Request/RecruitmentRequest/RecruitmentDecisionPage.vue'),
    children: [
        {
            path: '/recruitment_decisions/edit/:id',
            name: 'recruitment_decisions.edit',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentDecision.vue'),
            props: {updateAction: true},
            children: [
                {
                    path: '/recruitment_decisions/edit/interview/view/:id',
                    name: 'recruitment_decisions.edit.interview.view',
                    component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/recruitment_decisions/edit/cv_techs/view/:id',
                    name: 'recruitment_decisions.edit.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                    props: {viewAction: true}
                },
            ]
        },
        {
            path: '/recruitment_decisions/view/:id',
            name: 'recruitment_decisions.view',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentDecision.vue'),
            props: {viewAction: true},
            children: [
                {
                    path: '/recruitment_decisions/view/interview/view/:id',
                    name: 'recruitment_decisions.view.interview.view',
                    component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/recruitment_decisions/view/cv_techs/view/:id',
                    name: 'recruitment_decisions.view.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                    props: {viewAction: true}
                },
            ]
        },
        {
            path: '/recruitment_decisions/lock/:id',
            name: 'recruitment_decisions.lock',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentDecision.vue'),
            props: {lockAction: true},
            children: [
                {
                    path: '/recruitment_decisions/lock/interview/view/:id',
                    name: 'recruitment_decisions.lock.interview.view',
                    component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationRecruitmentInterviewForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/recruitment_decisions/lock/cv_techs/view/:id',
                    name: 'recruitment_decisions.lock.cv_techs.view',
                    component: () => import('@/views/Recruitment/CvTech/Form/CvTechForm.vue'),
                    props: {viewAction: true}
                },
            ]
        },
        {
            path: '/recruitment_decisions/documents/:id',
            name: 'recruitment_decisions.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "RECRUITMENT_REQUEST"}
        },
        {
            path: '/recruitment_decisions/template_applications/:id',
            name: 'recruitment_decisions.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "RECRUITMENT_REQUEST"}
        },
    ],
}